import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ApexOptions } from 'ng-apexcharts';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { ResearchService } from 'app/modules/research/research.service';
import { ProjectInsightsService } from 'app/modules/projects/details/insights/insights.service';
import { Property } from 'app/modules/projects/projects.types';

@Component({
  selector: 'project-insights-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectInsightsMarketComponent implements OnInit {
  public postalCode = null;
  public demographics = null;
  public aggregateMarketDemographics = null;
  public employment = null;
  public permitsSurvey = null;
  public property: Property;
  public latitude = null;
  public longitude = null;

  blsUnemploymentOptions: ApexOptions;
  blsUnemploymentData: any;

  censusPermitsOptions: ApexOptions;
  censusPermitsData: any;

  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _researchService: ResearchService,
    private _projectInsightsService: ProjectInsightsService,
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this._projectInsightsService.property$.pipe(takeUntil(this._unsubscribeAll)).subscribe((property: Property) => {
      this.property = property;

      this.postalCode = this.property.address?.postal_code;
      this.latitude = this.property.address?.latitude;
      this.longitude = this.property.address?.longitude;

      this.loadData();
      // Mark for check
      this._changeDetectorRef.markForCheck();
    });
  }

  loadData(): void {
    if (this.latitude && this.longitude) {
      this._researchService
        .getAllAggregateMarketDemographics(this.latitude, this.longitude, 'BLOCK_GROUP', 'MILES')
        .subscribe((data) => {
          this.aggregateMarketDemographics = data;
          this._changeDetectorRef.markForCheck();
        });
    }

    if (this.postalCode) {
      this._researchService.getDemographicData(this.postalCode).subscribe((data) => {
        this.demographics = data;
        this._changeDetectorRef.markForCheck();
      });
    }
  }
}
